import { createStyles, makeStyles } from '@material-ui/core';

export const styles = makeStyles(() =>
  createStyles({
    root: {
      overflow: 'auto',
    },
  }),
);
